import { PageSection, PageWrapper } from '@src/components';
import { useTranslation } from 'react-i18next';
import { PayoutsList } from './PayoutsList';
import { useGetAffiliatePayoutQuery } from '@src/services/affiliate/affiliateApiSlice';

export function PayoutView() {
  const { t } = useTranslation();
  const { data, isLoading, isFetching } = useGetAffiliatePayoutQuery({});

  return (
    <PageWrapper loading={isLoading || isFetching} rootClassName='space-y-6'>
      <PageSection className='bg-wl-background p-4 space-y-4'>
        <div className='text-M-16 text-wl-on-surface'>
          {t('pages.affiliate.payout.payoutSetting')}
        </div>
        <div className='bg-wl-background grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4'>
          <div className='space-y-2'>
            <div className='text-M-14 text-wl-on-surface'>
              {t('pages.affiliate.payout.bankName')}
            </div>
            <PageSection className='bg-wl-surface text-wl-on-surface text-M-16'>
              {data?.payoutBankName ?? '---'}
            </PageSection>
          </div>
          <div className='space-y-2'>
            <div className='text-M-14 text-wl-on-surface'>
              {t('pages.affiliate.payout.accountNumber')}
            </div>
            <PageSection className='bg-wl-surface text-wl-on-surface text-M-16'>
              {data?.payoutAccountNumber ?? '---'}
            </PageSection>
          </div>
          <div className='space-y-2'>
            <div className='text-M-14 text-wl-on-surface'>
              {t('pages.affiliate.payout.ibanSwiftCode')}
            </div>
            <PageSection className='bg-wl-surface text-wl-on-surface text-M-16'>
              {data?.payoutIbanOrSwift ?? '---'}
            </PageSection>
          </div>
          <div className='space-y-2'>
            <div className='text-M-14 text-wl-on-surface'>
              {t('pages.affiliate.payout.currency')}
            </div>
            <PageSection className='bg-wl-surface text-wl-on-surface text-M-16'>
              {data?.payoutCurrency ?? '---'}
            </PageSection>
          </div>
        </div>
      </PageSection>

      <PageSection className='bg-wl-alert-container-light dark:bg-wl-background text-wl-on-background p-6'>
        <p className='text-R-14'>{t('pages.affiliate.payout.info')}</p>
      </PageSection>
      <PageSection>
        <PayoutsList />
      </PageSection>
    </PageWrapper>
  );
}
